import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { WhoIsItFor } from './components/WhoIsItFor';
import { Problem } from './components/Problem';
import { ProductoStats } from './components/ProductoStats';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparativa } from './components/Comparativa';
import { ModuloProfesional } from './components/ModuloProfesional';
import { Pricing } from './components/Pricing';
import { PlanProfesionalBeneficios } from './components/PlanProfesionalBeneficios';
import { Garantia } from './components/Garantia';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    try {
      const w = window as any;
      if (!w.fbq) {
        const fbq: any = function (...args: any[]) {
          fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
        };
        if (!w._fbq) w._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        w.fbq = fbq;
        // Inject the Meta Pixel script safely into <head> instead of
        // relying on an existing <script> tag's parentNode.
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (err) {
      // Never let analytics break the page.
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <div className="min-h-screen bg-lsa-dark font-sans selection:bg-lsa-celeste selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="flex flex-col" data-id="element-2">
        <Hero data-id="element-3" />
        <Reviews data-id="element-4" />
        <WhoIsItFor data-id="element-5" />
        <Problem data-id="element-6" />
        <ProductoStats data-id="element-7" />
        <Tomos data-id="element-8" />
        <Bonos data-id="element-9" />
        <Comparativa data-id="element-10" />
        <ModuloProfesional data-id="element-11" />
        <Pricing data-id="element-12" />
        <PlanProfesionalBeneficios data-id="element-13" />
        <Garantia data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}